import { useState, useEffect } from 'react'

import Listing from './components/Listing'
import Detail from './components/Detail'

import './App.scss'

function App() {
    const urlParams = new URLSearchParams(window.location.search)

    const [channelId, setChannelId] = useState(null)

    const channelIds = {
        'en': 17728010,
        'de': 17728072,
        'no': 17728010,
        'se': 17728073,
        'dk': 17728074,
        'fi': 17728076,
        'pl': 17728075,
        // 'de': 17728072,
    }

    useEffect(() => {
        if (window && window.location) {
            if (decodeURIComponent(window?.location?.href)?.includes('/en/')) {
                setChannelId('en')
            } else if (decodeURIComponent(window?.location?.href)?.includes('/no/')) {
                setChannelId('no')
            } else if (decodeURIComponent(window?.location?.href)?.includes('/sv/')) {
                setChannelId('se')
            } else if (decodeURIComponent(window?.location?.href)?.includes('/da/')) {
                setChannelId('dk')
            } else if (decodeURIComponent(window?.location?.href)?.includes('/fi/')) {
                setChannelId('fi')
            } else if (decodeURIComponent(window?.location?.href)?.includes('/pl/')) {
                setChannelId('pl')
            } else if (decodeURIComponent(window?.location?.href)?.includes('/de/')) {
                setChannelId('de')
            } else {
                setChannelId('no')
            }
        }
    }, [])

    return (
        <>
            {
                // if url param articleId exists, show detail page, else show listing page
                urlParams.get('id')
                ? 
                <Detail articleId={urlParams.get('id')} />
                :
                <Listing 
                    channelId={channelIds[channelId]} 
                    setChannelId={setChannelId} 
                    channelIds={channelIds}
                />
            }
        </>
    )
}

export default App
